var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/placeholder/components/placeholder_status.tsx";
import classNames from 'classnames';
import * as React from 'react';
import PlaceholderAvatar from './placeholder_avatar';
import PlaceholderDisplayName from './placeholder_display_name';
import PlaceholderStatusContent from './placeholder_status_content';
/** Fake status to display while data is loading. */
const PlaceholderStatus = ({
  timeline = false
}) => /*#__PURE__*/React.createElement("div", {
  className: classNames({
    'status-placeholder bg-white dark:bg-slate-800': true,
    'shadow-xl dark:shadow-inset sm:rounded-xl px-4 py-6 sm:p-5 from-primary-500/10 dark:from-primary-200/10 to-white dark:via-slate-800 dark:to-slate-800': timeline
  }),
  style: {
    background: 'linear-gradient(to bottom, var(--tw-gradient-from) 0px, var(--tw-gradient-to) 50px, var(--tw-gradient-to) 100%)'
  },
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 14,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "w-full animate-pulse overflow-hidden",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 25,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement("div", {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 26,
    columnNumber: 7
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "flex space-x-3 items-center",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 27,
    columnNumber: 9
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "flex-shrink-0",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 28,
    columnNumber: 11
  }
}, /*#__PURE__*/React.createElement(PlaceholderAvatar, {
  size: 42,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 29,
    columnNumber: 13
  }
})), /*#__PURE__*/React.createElement("div", {
  className: "min-w-0 flex-1",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 32,
    columnNumber: 11
  }
}, /*#__PURE__*/React.createElement(PlaceholderDisplayName, {
  minLength: 3,
  maxLength: 25,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 33,
    columnNumber: 13
  }
})))), /*#__PURE__*/React.createElement("div", {
  className: "mt-4 status__content-wrapper",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 38,
    columnNumber: 7
  }
}, /*#__PURE__*/React.createElement(PlaceholderStatusContent, {
  minLength: 5,
  maxLength: 120,
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 39,
    columnNumber: 9
  }
}))));
export default /*#__PURE__*/React.memo(PlaceholderStatus);